import { render } from "./Catalogue.vue?vue&type=template&id=edece010&scoped=true"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=edece010&scoped=true&lang=css"

import exportComponent from "C:\\dev-intelij\\MC-production\\widget-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edece010"]])

export default __exports__